import useTranslation from "next-translate/useTranslation";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectors as ListingsReducerSelectors } from "redux/slices/v2/ListingReducer";
import Dropdown from "../DropDown/DropDown";
import InputSelect from "../PriceRangeSelect/InputSelect";
import classes from "./SurfaceRangeSelect.module.scss";
import CheckMark from "ui/CheckMark/CheckMark";

export default function SurfaceRangeSelect({
  transactionType,
  onSurfaceRangeChange,
}: {
  transactionType: "Vente" | "Location" | "Projets Neufs" | "";
  onSurfaceRangeChange: ({
    minSurface,
    maxSurface,
    exclusivite,
    virtual_tour,
  }: {
    minSurface?: any;
    maxSurface?: any;
    exclusivite?: any;
    virtual_tour?: any;
  }) => void;
}) {
  const { t } = useTranslation("commonAnnonces");
  const searchPayload = useSelector(
    ListingsReducerSelectors.searchPayloadSelector
  );
  const [label, setLabel] = useState("Plus");
  useEffect(() => {
    setLabel(
      `${searchPayload
        ? searchPayload.surfacemin || searchPayload.surfacemax
          ? valuesFormatters([
            searchPayload.surfacemin,
            searchPayload.surfacemax,
          ])
          : t("Plus")
        : t("Plus")
      }`
    );
  }, [searchPayload]);
  const valuesFormatters = (selected: (number | "")[]) => {
    if (selected[0] && selected[1]) {
      return `${selected[0]} - ${selected[1]} ${t("m²")}`;
    } else if (selected[0]) {
      return `>${selected[0]} ${t("m²")}`;
    } else if (selected[1]) {
      return `<${selected[1]} ${t("m²")}`;
    }
    return t("Surface");
  };

  const [dropdownToggle, setDropdownToggle] = useState<boolean>(false);
  const [minValue, setMinValue] = useState(
    searchPayload?.surfacemin ? searchPayload.surfacemin : ""
  );
  const [maxValue, setMaxValue] = useState(
    searchPayload?.surfacemax ? searchPayload.surfacemax : ""
  );

  const [checkedVirtual3D, setCheckedVirtual3D] = useState(
    searchPayload?.virtual_tour ? searchPayload?.virtual_tour : false
  );
  const [checkedExclu, setCheckedExclu] = useState(
    searchPayload?.exclusivite ? searchPayload?.exclusivite : false
  );

  useEffect(() => {
    setCheckedVirtual3D(searchPayload?.virtual_tour ? searchPayload?.virtual_tour : false)
    setCheckedExclu(
      searchPayload?.exclusivite ? searchPayload?.exclusivite : false
    )
  }, [searchPayload])

  const contentComponent = (
    // <RangeSelect
    //   // valuesFormatters={valuesFormatters}
    //   label={t("Surface")}
    //   minValuesList={[0, 25, 50, 75, 100, 150, 200, 300, 500]}
    //   maxValuesList={[50, 75, 100, 150, 200, 300, 400, 500, 750, 1000]}
    //   onRangeSelect={({ minValue, maxValue }) => {
    //     setDropdownToggle(false);
    //     onSurfaceRangeChange({
    //       minSurface: minValue,
    //       maxSurface: maxValue,
    //     });
    //   }}
    //   defaultMaxValue={
    //     searchPayload
    //       ? searchPayload.surfacemax
    //         ? searchPayload.surfacemax
    //         : ""
    //       : ""
    //   }
    //   defaultMinValue={
    //     searchPayload
    //       ? searchPayload.surfacemin
    //         ? searchPayload.surfacemin
    //         : ""
    //       : ""
    //   }
    //   unit={"m²"}
    // />
    <div style={{ padding: 0, margin: 0 }}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div className={classes.componentTitle}>
          <span className={classes.title}>{t("Plus")}</span>
        </div>
        <div className={classes.checks_container}>
          <div className={classes.componentTitleInside}>
            <span className={classes.title}>{t("Visite 3D")}</span>
          </div>
          <div
            className={classes.checkbox}
            onClick={() => {
              setCheckedVirtual3D(!checkedVirtual3D);
            }}
          >
            <CheckMark checked={checkedVirtual3D} isBlue={true} />
            <p className={classes.checkedText}>Annonces avec visite 3D</p>
          </div>
        </div>
        <div className={classes.checks_container}>
          <div className={classes.componentTitleInside}>
            <span className={classes.title}>{t("Exclusivités agenz")}</span>
          </div>
          <div
            className={classes.checkbox}
            onClick={() => {
              setCheckedExclu(!checkedExclu);
            }}
          >
            <CheckMark checked={checkedExclu} isBlue={true} />
            <p className={classes.checkedText}>Annonces exclusives agenz</p>
          </div>
        </div>
        <div className={classes.checks_container}>
          <div className={classes.componentTitleInside}>
            <span className={classes.title}>{t("Surface")}</span>
          </div>
          <div className={classes.max_min_container}>
            <div className={classes.maximum_prix}>
              <span className={classes.prix_text}>{t("Minimum")}</span>
              <div style={{ width: "100%", height: "44px" }}>
                <InputSelect
                  array={[0, 25, 50, 75, 100, 150, 200, 300, 500]}
                  defaultValue={minValue}
                  setDefaultValue={setMinValue}
                  placeHolder={t("0 m²")}
                  maxValue={9999999999999}
                  name="minValueInputSurface"
                  symbol={t("m²")}
                />
              </div>
            </div>
            <div className={classes.separator_container}>
              <span className={classes.separator}>-</span>
            </div>
            <div className={classes.maximum_prix}>
              <span className={classes.prix_text}>{t("Maximum")}</span>
              <div style={{ width: "100%", height: "44px" }}>
                <InputSelect
                  array={[50, 75, 100, 150, 200, 300, 400, 500, 750, 1000]}
                  defaultValue={maxValue}
                  setDefaultValue={setMaxValue}
                  placeHolder={t("Aucun")}
                  maxValue={9999999999999}
                  name="maxValueInputSurface"
                  symbol={t("m²")}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={classes.validBtnWrapper}>
          <span
            className={classes.validBtn}
            onClick={() => {
              onSurfaceRangeChange({
                minSurface: parseInt(minValue.toString()),
                maxSurface: parseInt(maxValue.toString()),
                exclusivite: checkedExclu,
                virtual_tour: checkedVirtual3D,
              });
              setDropdownToggle(false);
            }}
          >
            {t("Valider")}
          </span>
        </div>
      </div>
    </div>
  );

  const valueComponent = <span className={classes.label}>{t(label)}</span>;

  return (
    <>
      <Dropdown
        liststyling={classes.liststyling}
        className={`${classes.btnWrapper} ${searchPayload
          ? searchPayload.surfacemin || searchPayload.surfacemax
            ? classes.btnWrapperActive
            : ""
          : ""
          }`}
        t={t}
        contentComponent={contentComponent}
        valueComponent={valueComponent}
        toggleBtnStyle={classes.toggleBtnStyle}
        onToggleActive={classes.toggleBtnActive}
        dropdownToggle={dropdownToggle}
        setDropdownToggle={setDropdownToggle}
      />
    </>
  );
}
